<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <span class="ml-3 f14 font-weight-bold text-uppercase"
          >Habilidades técnicas
        </span>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-4 col-xs-12">
        <button
          class="btn btn-primary full p-2 radius-0 f13 text-uppercase"
          v-if="!showForm"
          :disabled="!job_id"
          @click="showForm = true"
        >
          Adicionar habilidade técnica
        </button>
        <div v-if="showForm">
          <VueSuggestion
            searchURL="/recruiters/skills/search"
            responseDataName="skills"
            :whenSelected="createJobSkill"
            v-model.trim="input"
            queryParamName="term"
            classes="mt-1"
            inputClasses="radius-0 form-control"
          />
          <div class="d-flex">
            <button class="btn btn-primary full" @click="createJobSkill">
              Adicionar
            </button>
            <button class="btn btn-danger full" @click="showForm = false">
              Cancelar
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-xs-12">
        <div
          class="row mb-3 font-weight-bold text-uppercase"
          v-if="job_skills.length"
        >
          <div class="col-lg-7">
            <span>Nome</span>
          </div>
          <div class="col-lg-5">
            <span>Peso</span>
          </div>
        </div>
        <div class="row" v-for="(skill, index) in job_skills" :key="skill.id">
          <div class="col-lg-7">
            <div class="d-table w-100 h-100">
              <div class="d-table-cell align-middle">
                <span>{{ skill.name }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <input
              type="number"
              step="0.5"
              min="1"
              v-model.number="skill.weight"
              @change="updateJobSkill(skill)"
              placeholder="Peso"
              class="form-control"
            />
          </div>
          <div class="col-lg-1">
            <div class="d-table w-100 h-100">
              <div class="d-table-cell align-middle">
                <font-awesome-icon
                  icon="times"
                  class="text-danger pointer"
                  title="Deletar habilidade técnica"
                  @click="deleteJobSkill(skill.id, index)"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <hr />
          </div>
        </div>
      </div>
    </div>
    <hr class="bg-aqua my-4" />
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";

export default {
  props: ["job_id"],
  components: { VueSuggestion },
  data: () => ({
    showForm: false,
    job_skills: [],
    skills: [],
    input: "",
  }),
  watch: {
    job_id: function () {
      this.getJobSkills();
    },
  },
  methods: {
    duplicated(name, skill_id) {
      let duplicated = false;
      for (let skill of this.job_skills) {
        if (skill.name == name || skill.skill_id == skill_id) {
          duplicated = true;
          break;
        }
      }

      return duplicated;
    },
    getJobSkills() {
      if (!this.job_id) return;

      this.job_skills = [];
      axios.get(`/recruiters/job_skills/${this.job_id}`).then((response) => {
        this.job_skills = response.data.job_skills;
      });
    },
    searchSkills() {
      this.skill = this.skill.toLowerCase();
      axios
        .get(`/recruiters/skills/search?term=${this.skill}`)
        .then((response) => {
          this.skills = response.data.skills;
        });
    },
    updateJobSkill(skill) {
      if (!skill.weight > 0) {
        this.$toast.error("Por favor, insira um peso válido.");
        return;
      }

      let job_skills = {
        weight: skill.weight,
      };

      axios
        .post(`/recruiters/job_skills/${skill.id}`, { job_skills })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteJobSkill(id, index) {
      let conf = confirm(
        "Tem certeza que deseja remover está habilidade técnica?"
      );
      if (!conf) return;

      axios.delete(`/recruiters/job_skills/${id}`).then((response) => {
        if (response.data.status) {
          this.job_skills.splice(index, 1);
          this.$toast.success("habilidade excluida com sucesso!");
          return;
        }

        this.$toast.error("Não foi possivel excluir esta habilidade!");
      });
    },
    createJobSkill(skill) {
      let job_skills = {
        name: this.input.toLowerCase(),
        job_id: this.job_id,
        skill_id: (skill || {}).id,
      };
      if (!job_skills.name.length) return;

      if (this.duplicated(job_skills.name, job_skills.skill_id)) {
        this.$toast.error("Esta habilidade já foi adicionada");
        eventBus.$emit(`clearAll-skills`);
        return;
      }

      axios.post("/recruiters/job_skills", { job_skills }).then((response) => {
        eventBus.$emit(`clearAll-skills`);
        this.showForm = false;

        if (response.status) {
          this.job_skills.push(response.data.job_skill);
          return;
        }

        this.$toast.error("Não foi possivel adicionar esta habilidade");
      });
    },
  },
};
</script>